module.exports = __webpack_public_path__ + "static/media/Beach12.7c240302.jpg";